import * as R from "ramda";
import { ModemModel } from "../../../generated/openapi/models";

const isCustomer = (modem: ModemModel): boolean => {
    return !R.isNil(modem.bookedDownloadSpeedMax) && !R.isNil(modem.bookedUploadSpeedMax)
}

export default isCustomer;